const PositionFiltersComponent = ({ filters, setFilters }) => {

    const handleChange = (e) => {
        setFilters((oldFilters) => {
            return {
                ...oldFilters,
                [e.target.name]: e.target.value,
                page: 1
            }
        });
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-6  p-3">
                    <div className="form-group">
                        <div className="card p-3">
                            <label className="form-label">Id</label>
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Id"
                                value={filters?.id}
                                onChange={handleChange}
                                name="id" />
                        </div>
                    </div>
                </div>
                <div className="col-md-6 p-3">
                    <div className="card p-3">
                        <div className="form-group">
                            <label className="form-label">Mes y año</label>
                            <input
                                className="form-control"
                                type="month"
                                name="month"
                                value={filters?.month}
                                onChange={handleChange}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PositionFiltersComponent;